/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@material-ui/core';
import { NewReleases as NewReleaseIcon } from '@material-ui/icons';
import { selectAnnouncements, fetchAnnouncements } from '../../store/layoutSlice';

export default function NotificationList() {
  const dispatch = useDispatch();
  const announcements = useSelector(selectAnnouncements);

  /* useEffect(() => {
    dispatch(fetchAnnouncements());
  }, [dispatch]); */

  return (
    <List dense>
      {announcements && announcements.map((announcement) => (
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <NewReleaseIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={announcement.message}
            secondary={announcement.datetime}
          />
        </ListItem>
      ))}
      { announcements && announcements.length === 0 ? (
        <ListItem>
          <ListItemText
            primary="No Announcements"
          />
        </ListItem>
      ) : '' }
    </List>
  );
}
